<div class="lg:px-6 px-1 py-5">
  <div class="surface-card p-4 shadow-2 border-round">
    <div class="flex flex-wrap align-items-center gap-2">
      <button
        *appHasPermission="'subscriptions.edit'; fallbackRoles: ['superadmin', 'portalmanagement_admin', 'operationsadmin']"
        type="button"
        pButton
        pTooltip="Change Anniversary Date"
        tooltipPosition="top"
        icon="pi pi-calendar"
        label="Change Anniversary Date"
        [loading]="loadingAnniversary"
        (click)="showUpdateSubscriptionDialog(subscription, $event)"
        class="p-button-sm p-button-outlined"
      ></button>

      <button
        *appHasPermission="'subscriptions.regrade'; fallbackRoles: ['superadmin', 'portalmanagement_admin', 'operationsadmin']"
        type="button"
        pButton
        pTooltip="Regrade Subscription"
        tooltipPosition="top"
        icon="pi pi-upload"
        label="Regrade Subscription"
        class="p-button-sm p-button-success p-button-outlined"
        [loading]="loadingRegrade"
        (click)="showRegradeSubscriptionDialog(subscription, $event)"
      ></button>

      <button
        type="button"
        pButton
        icon="pi pi-ellipsis-v"
        label="More Actions"
        class="p-button-sm p-button-text"
        (click)="moreActionsPanel.toggle($event)"
      ></button>
    </div>

    <p-overlayPanel
      #moreActionsPanel
      appendTo="body"
      [showCloseIcon]="false"
      [style]="{ width: '280px' }"
    >
      <div class="flex flex-column gap-1">
        <span class="text-500 text-xs font-semibold uppercase px-2 pt-1">Billing &amp; Commission</span>

        <button
          *appHasPermission="'subscriptions.view'; fallbackRoles: ['superadmin', 'portalmanagement_admin', 'operationsadmin']"
          type="button"
          pButton
          icon="pi pi-download"
          label="Download Statement"
          class="p-button-text p-button-plain w-full justify-content-start"
          [loading]="loadingStatement"
          (click)="downloadSubscriptionStatement(subscription); moreActionsPanel.hide()"
        ></button>

        <button
          *appHasPermission="'invoices.create'; fallbackRoles: ['superadmin', 'portalmanagement_admin', 'operationsadmin']"
          type="button"
          pButton
          icon="pi pi-dollar"
          label="Generate Manual Billing"
          class="p-button-text p-button-plain w-full justify-content-start"
          [loading]="loadingManualBill"
          (click)="manualBillSubscription(subscription); moreActionsPanel.hide()"
        ></button>

        <ng-container *ngIf="!subscription?.agent_commission_paid">
          <button
            *appHasPermission="'subscriptions.agent_commission'; fallbackRoles: ['superadmin', 'portalmanagement_admin']"
            type="button"
            pButton
            icon="pi pi-check-square"
            label="Agent Commission"
            class="p-button-text p-button-plain w-full justify-content-start"
            (click)="openAgentCommissionDialog(subscription); moreActionsPanel.hide()"
          ></button>
        </ng-container>

        <p-divider styleClass="my-1"></p-divider>

        <span class="text-500 text-xs font-semibold uppercase px-2 pt-1">Circuit</span>

        <button
          *appHasPermission="'subscriptions.change_device'; fallbackRoles: ['superadmin', 'portalmanagement_admin', 'operationsadmin']"
          type="button"
          pButton
          icon="pi pi-link"
          label="Claim Circuit"
          class="p-button-text p-button-plain w-full justify-content-start"
          (click)="showClaimCircuitDialog(subscription, $event); moreActionsPanel.hide()"
        ></button>

        <button
          *appHasPermission="'subscriptions.override'; fallbackRoles: ['superadmin', 'portalmanagement_admin']"
          type="button"
          pButton
          icon="pi pi-pencil"
          label="Change Account Reference"
          class="p-button-text p-button-plain w-full justify-content-start"
          (click)="showChangeAccountReferenceDialog(subscription, $event); moreActionsPanel.hide()"
        ></button>

        <p-divider styleClass="my-1"></p-divider>

        <span class="text-500 text-xs font-semibold uppercase px-2 pt-1">Escalations &amp; Cancellation</span>

        <button
          *appHasPermission="'subscriptions.reactivate'; fallbackRoles: ['portalmanagement_user']"
          type="button"
          pButton
          icon="pi pi-refresh"
          label="Reactivate Subscription"
          class="p-button-text p-button-plain w-full justify-content-start"
          [loading]="loadingActivation"
          (click)="showRequestReactivateSubscriptionDialog(subscription, $event); moreActionsPanel.hide()"
        ></button>

        <button
          *appHasPermission="'subscriptions.override'; fallbackRoles: ['superadmin', 'portalmanagement_admin', 'operationsadmin']"
          type="button"
          pButton
          icon="pi pi-refresh"
          label="Request Override"
          class="p-button-text p-button-plain w-full justify-content-start"
          [loading]="loadingOverride"
          (click)="showRequestOverrideSubscriptionDialog(subscription, $event); moreActionsPanel.hide()"
        ></button>

        <ng-container *ngIf="subscription?.subscription_reference_external">
          <button
            *appHasPermission="'subscriptions.remove_recurring_payment'; fallbackRoles: ['portalmanagement_user']"
            type="button"
            pButton
            icon="pi pi-credit-card"
            label="Remove Recurring Payment"
            class="p-button-text p-button-plain w-full justify-content-start"
            [loading]="loadingRemoveRecurringPayment"
            (click)="removeRecurringPayment(subscription); moreActionsPanel.hide()"
          ></button>
        </ng-container>

        <button
          *appHasPermission="'subscriptions.suspend'; fallbackRoles: ['superadmin', 'portalmanagement_admin']"
          type="button"
          pButton
          icon="pi pi-ban"
          label="Suspend Subscription"
          class="p-button-text p-button-plain w-full justify-content-start"
          [loading]="loadingSuspend"
          (click)="showSuspendSubscriptionDialog(subscription, $event); moreActionsPanel.hide()"
        ></button>

        <button
          *appHasPermission="'subscriptions.cancel'"
          type="button"
          pButton
          icon="pi pi-times"
          label="Cancel Subscription"
          class="p-button-text p-button-plain w-full justify-content-start"
          [loading]="loadingActivation"
          (click)="showCancelRequestDialog(subscription, $event); moreActionsPanel.hide()"
        ></button>
      </div>
    </p-overlayPanel>
  </div>
</div>

<p-confirmDialog header="Request Reactivate Subscription" key="reactivate"></p-confirmDialog>
<p-confirmDialog header="Request Override Subscription" key="override"></p-confirmDialog>
<p-confirmDialog header="Suspend Subscription" key="suspend"></p-confirmDialog>
